import { sva } from '@portal/styled-system/css'

export const gameOverlayRecipe = sva({
    slots: ['overlay', 'bubble', 'bubbleText'],
    base: {
        overlay: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'full',
            isolation: 'isolate',
            _before: {
                content: '""',
                position: 'absolute',
                inset: '0',
                backgroundImage: 'linear-gradient(to left bottom, rgba(160, 255, 238, 0.6), rgba(133, 216, 255, 0.6))',
                zIndex: 0,
            },
            '& > *': {
                position: 'relative',
                zIndex: 1,
            },
        },
        bubble: {
            width: '[334px]',
            height: '[174px]',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
        },
        bubbleText: {
            fontSize: 'md',
            paddingLeft: '[48px]',
            paddingRight: '[28px]',
            margin: '0',
            color: '[#673928]',
        },
    },
    variants: {
        bubblePosition: {
            default: {
                bubble: {
                    marginLeft: '[-40px]',
                    marginBottom: '[140px]',
                },
            },
            technical: {
                bubble: {
                    marginLeft: '[-70px]',
                    marginBottom: '[300px]',
                },
            },
            upgrade: {
                bubble: {
                    marginLeft: '[-70px]',
                    marginBottom: '[416px]',
                },
            },
        },
    },
    defaultVariants: {
        bubblePosition: 'default',
    },
})
